export default "__VITE_ASSET__f52974cc__"